import _extends from "@babel/runtime/helpers/extends";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Yelp = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return /*#__PURE__*/React.createElement(StyledIconBase, _extends({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 20 20"
  }, props, {
    ref: ref
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.538 12.471l4.523 1.466s.647.119.64.552c-.004.305-.197.652-.197.652l-1.91 2.756s-.341.286-.686.286c-.344 0-.741-.537-.741-.537l-2.417-4.073s-.272-.594.05-.921c.295-.3.738-.181.738-.181zM11.57 10.6c.231.396.87.281.87.281l4.513-1.331s.615-.253.703-.589c.086-.337-.102-.743-.102-.743l-2.157-2.564s-.187-.324-.575-.357c-.428-.037-.691.486-.691.486l-2.55 4.05c.001-.001-.224.402-.011.767zM9.438 9.021c.531-.132.616-.911.616-.911l-.036-6.485s-.08-.8-.436-1.017c-.559-.342-.724-.164-.884-.14L4.951 1.873s-.367.123-.558.432c-.273.437.277 1.079.277 1.079l3.894 5.358s.385.401.874.279zm-.925 2.624c.013-.5-.595-.801-.595-.801L3.89 8.791s-.597-.248-.887-.075c-.221.132-.418.372-.437.583l-.262 3.259s-.039.565.106.822c.205.364.881.111.881.111l4.702-1.049c.182-.124.502-.136.52-.797zm1.169 1.759c-.404-.209-.887.224-.887.224l-3.148 3.498s-.393.535-.293.863c.094.308.25.461.47.569l3.162 1.007s.383.08.674-.005c.412-.121.336-.772.336-.772l.071-4.736c0 .001-.016-.455-.385-.648z"
  }));
});
Yelp.displayName = 'Yelp';
export var YelpDimensions = {
  height: 20,
  width: 20
};